import { Device, until } from '@helpers/media';
import useMedia from '@hooks/useMedia';
import { LinkButton } from '@stories/Components/Buttons/Button/Button';
import UspCard from '@stories/Components/Cards/UspCard/UspCard';
import TitleAndIntroduction from '@stories/Components/Misc/TitleAndIntroduction/TitleAndIntroduction';
import * as React from 'react';
import S from './Usps.styles';
const Usps = (props) => {
    const paddingOffset = useMedia([until(Device.TabletSmall), until(Device.TabletLarge)], [40, 80], 0);
    const rowMax = useMedia([
        until(Device.TabletSmall),
        until(Device.TabletLarge),
        until(Device.Desktop),
        until(Device.DesktopLarge),
    ], [1, 2, 3, 4], props.rowSize ?? 4);
    if (!props.items || props.items.length === 0) {
        return null;
    }
    return (React.createElement(S.Container, { background: props.background, translations: props.translations, "data-columns": props.rowSize, "data-is-carousel": props.hasMobileCarousel, "data-bg-colour": props.background },
        React.createElement(TitleAndIntroduction, { title: props.title, introduction: props.introduction, alignment: "centre" }),
        React.createElement(S.Grid, { mobileCarousel: props.hasMobileCarousel, paddingOffset: paddingOffset, translations: props.translations, carouselType: props.cardType, rowMax: rowMax }, props.items.map((item) => (React.createElement(UspCard, { key: item.id, ...item, alignment: props.cardTextAlignment ? props.cardTextAlignment : 'left', type: props.cardType })))),
        props.cta && (React.createElement(LinkButton, { buttonType: "tertiary", href: props.cta.url, target: props.cta.target }, props.cta.text))));
};
export default Usps;
